import routeParams from '../../../helpers/routeParams'


const GET_MESSAGES_LIST = 'dofe-bo/messages/GET_MESSAGES_LIST'
const GET_MESSAGES_LIST_SUCCESS = 'dofe-bo/messages/GET_MESSAGES_LIST_SUCCESS'
const GET_MESSAGES_LIST_FAIL = 'dofe-bo/messages/GET_MESSAGES_LIST_FAIL'

const ADD_MESSAGE = 'dofe-bo/messages/ADD_MESSAGE'
const ADD_MESSAGE_SUCCESS = 'dofe-bo/messages/ADD_MESSAGE_SUCCESS'
const ADD_MESSAGE_FAIL = 'dofe-bo/messages/ADD_MESSAGE_FAIL'

const BULK_ADD_MESSAGE = 'dofe-bo/messages/BULK_ADD_MESSAGE'
const BULK_ADD_MESSAGE_SUCCESS = 'dofe-bo/messages/BULK_ADD_MESSAGE_SUCCESS'
const BULK_ADD_MESSAGE_FAIL = 'dofe-bo/messages/BULK_ADD_MESSAGE_FAIL'

const SET_FILTER = 'dofe-bo/messages/SET_FILTER'
const SET_PARAMS = 'dofe-bo/messages/SET_PARAMS'
const SET_SETTINGS = 'dofe-bo/messages/SET_SETTINGS'


const initialState = {
    list: [],
    sort: '',
    offset: 0,
    limit: 20,
    pages: 1,
    count: null,
    filter: '',
    settings: null,
    loading: false,
    loaded: false
}

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case GET_MESSAGES_LIST:
            return {
                ...state,
                loading: true
            }
        case GET_MESSAGES_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                loaded: true,
                list: action.result,
                count: Number(action.headers['x-total-count']),
                pages: Math.ceil(Number(action.headers['x-total-count']) / state.limit) || state.pages
            }
        case GET_MESSAGES_LIST_FAIL:
            return {
                ...state,
                loading: false,
                loaded: false,
                error: action.error
            }
        case ADD_MESSAGE:
            return {
                ...state,
                loading: true
            }
        case ADD_MESSAGE_SUCCESS:
            return {
                ...state,
                loading: false,
                loaded: true
            }
        case ADD_MESSAGE_FAIL:
            return {
                ...state,
                loading: false,
                loaded: false,
                error: action.error
            }
        case SET_FILTER:
            return Object.assign({}, state, {
                filter: action.filterBy,
                offset: 0,
                invalidate: new Date().getTime()
            })
        case SET_SETTINGS:
            return Object.assign({}, state, {
                settings: action.settings
            })
        case BULK_ADD_MESSAGE:
            return {
                ...state,
                bulk: {
                    ...state.bulk,
                    loading: true,
                    loaded: false
                }
            }
        case BULK_ADD_MESSAGE_SUCCESS:
            return {
                ...state,
                bulk: {
                    ...state.bulk,
                    loading: false,
                    loaded: true,
                    detail: action.result
                }
            }
        case BULK_ADD_MESSAGE_FAIL:
            return {
                ...state,
                bulk: {
                    ...state.bulk,
                    loading: false,
                    error: action.error
                }
            }
        case SET_PARAMS:
            return {
                ...state,
                limit:
                    action.options.limit !== undefined
                        ? action.options.limit
                        : state.limit,
                offset:
                    action.options.offset !== undefined
                        ? action.options.offset
                        : state.offset,
                filter:
                    action.options.filter !== undefined
                        ? action.options.filter
                        : state.filter,
                sort:
                    action.options.sort !== undefined ? action.options.sort : state.sort
            }
        default:
            return state
    }
}

export function addMessage(data) {
    return {
        types: [ADD_MESSAGE, ADD_MESSAGE_SUCCESS, ADD_MESSAGE_FAIL],
        promise: client =>
            client.post('api/messages/create', {
                data
            })
    }
}

export function addMessages(data) {
    return {
        types: [BULK_ADD_MESSAGE, BULK_ADD_MESSAGE_SUCCESS, BULK_ADD_MESSAGE_FAIL],
        promise: client =>
            client.post('api/messages/create/bulk', {
                data
            })
    }
}

export function getMessages(params = {}, baseFilter, settings = '', { praiseOnly = false, newOnly = false } = {}) {
    return {
        types: [
            GET_MESSAGES_LIST,
            GET_MESSAGES_LIST_SUCCESS,
            GET_MESSAGES_LIST_FAIL
        ],
        promise: client => client.get(
            `api/messages/list?newOnly=${newOnly}&praiseOnly=${praiseOnly}&${routeParams(params, baseFilter)}&${settings}&sort=-createdAt`
        )
    }
}

export function setFilter(filterBy) {
    return {
        type: SET_FILTER,
        filterBy
    }
}

export function setSettings(settings) {
    return {
        type: SET_SETTINGS,
        settings
    }
}

export function setMessagesParams(options) {
    return {
        type: SET_PARAMS,
        options
    }
}


